export default "__VITE_ASSET__74da1a4f__"